import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/styles/index.scss' // global css
import './utils/flexible.js'
import Pagination from '@/components/Pagination/index.vue' // 分页
import Navbar from '@/components/Navbar'
import moment from "moment";
import 'moment/dist/locale/zh-cn'
moment.locale('zh-cn') //中文化

Vue.prototype.moment = moment;
Vue.config.productionTip = false

Vue.component('pagination', Pagination)
Vue.component('navbar', Navbar)
Vue.use(ElementUI);
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
